import { t } from "../../../features/store-language/i18n.ts";

export function normalizeAgencyPassword(value?: string) {
  return (value || "").normalize("NFC");
}

function hasRepeatedPattern(value: string) {
  const characters = Array.from(value);
  for (let patternLength = 1; patternLength <= characters.length / 2; patternLength++) {
    if (characters.length % patternLength !== 0) continue;
    if (characters.every(function (character, index) {
      return character === characters[index % patternLength];
    })) return true;
  }
  const words = value.trim().split(/\s+/u);
  return words.length > 1 && words.every(function (word) { return word === words[0]; });
}

export function agencyRegistrationPasswordRules() {
  return [{
    validator: async function (_: unknown, value?: string) {
      const normalized = normalizeAgencyPassword(value);
      const length = Array.from(normalized).length;
      if (!normalized.trim() || length < 8 || length > 256) {
        throw new Error(t("رمز عبور باید حداقل ۸ کاراکتر باشد."));
      }
      if (/^\s|\s$/u.test(normalized)) {
        throw new Error(t("رمز عبور نباید با فاصله شروع یا تمام شود؛ فاصله بین واژه‌ها مجاز است."));
      }
    },
  }];
}

export function agencyPasswordRules() {
  return [{
    validator: async function (_: unknown, value?: string) {
      const normalized = normalizeAgencyPassword(value);
      const length = Array.from(normalized).length;
      if (!normalized.trim() || length < 15 || length > 256) {
        throw new Error(t("رمز عبور باید حداقل ۱۵ کاراکتر باشد."));
      }
      if (hasRepeatedPattern(normalized)) {
        throw new Error(t("رمز عبور نباید از تکرار یک کاراکتر یا واژه ساخته شود؛ چند واژه نامرتبط انتخاب کنید."));
      }
      if (/^\s|\s$/u.test(normalized)) {
        throw new Error(t("رمز عبور نباید با فاصله شروع یا تمام شود؛ فاصله بین واژه‌ها مجاز است."));
      }
    },
  }];
}
